module.exports = __webpack_public_path__ + "static/investment-research-146de1fb86a3b8483543b8fef8be6204.png";